/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SortSpot {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  NUMERIC_NAME = "numericName",
  NAME = "name",
  SUB_PRICE = "subPrice",
  VAT_FREE_PRICE = "vatFreePrice",
}
